import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {ImageGalleryModel} from "../../shared/models/ui/image-gallery.model";
import {ApiService} from "../../core/api/api.service";

@Component({
    selector: 'bergh-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrls: ['./image-gallery.component.scss'],
    standalone: false
})
export class ImageGalleryComponent implements OnInit {

  @Input() data: ImageGalleryModel;
  @Input() pictures;
  @Input() firePartitionId:string;
  @Output() updateDeletePictureStatus: EventEmitter<any> = new EventEmitter();
  public colDivision: string;
  public role :any = localStorage.getItem('ROLE_CODE');
  public selectedImage: string;
  public toBeDeletedimageList : string[] = [];
  public rotateCount: string = '';
  public isSelected:boolean=false;
  public selectedImageIndices:number[]=[];

  constructor(private _apiService:ApiService,private _toastr:ToastrService) { }

  ngOnInit(): void {
    this.configureColumn(this.data.columns);

  }

  configureColumn(columns: number): void{
    let numberOfColumns = columns > 12 ? 12 : columns;
    numberOfColumns = numberOfColumns <= 0 ? 1 : numberOfColumns;
    this.colDivision = Math.floor(12 / numberOfColumns).toString();
  }
  rotateImage(){
    switch (this.rotateCount) {
      case '': {
        this.rotateCount = 'one';
        break;
      }
      case 'one': {
        this.rotateCount = 'two';
        break;
      }
      case 'two': {
        this.rotateCount = 'three';
        break;
      }
      case 'three': {
        this.rotateCount = '';
        break;
      }
      default: {
        break;
      }
    }
  }
  clickPicture(i): void {
    this.pictures[i].selected = !this.pictures[i].selected;
    if(this.pictures[i].selected==true){
     this.toBeDeletedimageList.push(this.pictures[i]._id as string);
     this.selectedImageIndices.push(i);
    }else{
      this.toBeDeletedimageList.forEach((element,index)=>{
        if(element==this.pictures[i]._id) this.toBeDeletedimageList.splice(index,1);
     });
      this.selectedImageIndices.forEach((element,index)=>{
        if(element==i) this.selectedImageIndices.splice(index,1);
     });
  }
}

  selectImage(): void{
        this.isSelected = true;
  }

  cancel(): void{
    this.isSelected=false;
  }

  deleteImages(i:number[]): void{
    if(this.toBeDeletedimageList.length>0){
      i.forEach((element)=>{
        this.data.images.forEach((ele,index)=>{
        if(index===element){
          this.data.images.splice(index,1);
        }
      })
    })
    this._apiService.request('deletePictures',{pictureIds:this.toBeDeletedimageList},`${this.firePartitionId}/pictures/delete`).subscribe((successResponse) => {
      if(successResponse){
        this._toastr.success('Succesvol verwijderd');
       i=[];
        this.toBeDeletedimageList = [];
        this.isSelected=false;
        this.updateDeletePictureStatus.emit(false);
      }

    }, (error:any)=>{
      this._toastr.error(error);
    })
  }else{
    this._toastr.warning('Selecteer ten minste één afbeelding!');
  }
  }

}
